<template>
  <form @submit.prevent="saveProperty" class="w-full">
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[15px] sm:p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-[15px] sm:gap-[25px]">
          <!-- Property Title - New Field -->
          <div class="mb-[15px] sm:mb-0 sm:col-span-2">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Property Title
            </label>
            <input
              type="text"
              v-model="property.title"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              placeholder="Enter property title"
            />
          </div>

          <!-- Property Status -->
          <div class="mb-[15px] sm:mb-0">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Property Status
            </label>
            <select
              v-model="property.status"
              class="h-[55px] rounded-md border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[13px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500"
            >
              <option value="">Select</option>
              <option value="available">Available</option>
              <option value="rented">Rented</option>
              <option value="sold">Sold</option>
              <option value="pending">Pending</option>
              <option value="off-market">Off Market</option>
            </select>
          </div>

          <!-- Rent or Sale -->
          <div class="mb-[15px] sm:mb-0">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Rent or Sale
            </label>
            <select
              v-model="property.rent_or_sale"
              class="h-[55px] rounded-md border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[13px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500"
            >
              <option value="">Select</option>
              <option value="rent">Rent</option>
              <option value="sale">Sale</option>
            </select>
          </div>

          <!-- Property Price -->
          <div class="mb-[15px] sm:mb-0">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Property Price
            </label>
            <input
              type="number"
              v-model="property.price"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              placeholder="Price"
              step="0.01"
            />
          </div>

          <!-- Property Type -->
          <div class="mb-[15px] sm:mb-0">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Property Type
            </label>
            <select
              v-model="property.property_type"
              class="h-[55px] rounded-md border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[13px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500"
            >
              <option value="">Select</option>
              <option value="apartment">Apartment</option>
              <option value="house">House</option>
              <option value="townhouse">Townhouse</option>
              <option value="condo">Condominium</option>
              <option value="detached">Detached House</option>
              <option value="multifamily">Multifamily</option>
              <option value="bungalow">Bungalow</option>
              <option value="commercial">Commercial</option>
              <option value="land">Land</option>
            </select>
          </div>

          <!-- Bedrooms -->
          <div class="mb-[15px] sm:mb-0">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Bedrooms
            </label>
            <input
              type="number"
              v-model="property.bedroom"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              placeholder="2.5"
              step="0.5"
            />
          </div>

          <!-- Bathrooms -->
          <div class="mb-[15px] sm:mb-0">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Bathrooms
            </label>
            <input
              type="number"
              v-model="property.bathroom"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              placeholder="1.5"
              step="0.5"
            />
          </div>

          <!-- Size -->
          <div class="mb-[15px] sm:mb-0">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Size (sqm)
            </label>
            <input
              type="number"
              v-model="property.size"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              placeholder="Size in square meters"
              step="0.01"
            />
          </div>

          <!-- Year Built -->
          <div class="mb-[15px] sm:mb-0">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Year Built
            </label>
            <input
              type="number"
              v-model="property.year_built"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              placeholder="2023"
            />
          </div>

          <!-- Country -->
          <div class="mb-[15px] sm:mb-0">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Country
            </label>
            <input
              type="text"
              v-model="property.country"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              placeholder="Country"
            />
          </div>

          <!-- City -->
          <div class="mb-[15px] sm:mb-0">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              City
            </label>
            <input
              type="text"
              v-model="property.city"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              placeholder="City"
            />
          </div>

          <!-- Address -->
          <div class="mb-[15px] sm:mb-0">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Address
            </label>
            <input
              type="text"
              v-model="property.address"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              placeholder="Full address"
            />
          </div>

          <!-- Floor -->
          <div class="mb-[15px] sm:mb-0">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Floor
            </label>
            <input
              type="number"
              v-model="property.floor"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              placeholder="Current floor"
            />
          </div>

          <!-- Total Floors -->
          <div class="mb-[15px] sm:mb-0">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Total Floors
            </label>
            <input
              type="number"
              v-model="property.total_floors"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              placeholder="Total floors in building"
            />
          </div>

          <!-- Availability Date -->
          <div class="mb-[15px] sm:mb-0">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Availability Date
            </label>
            <input
              type="date"
              v-model="property.availability_date"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
            />
          </div>

          <!-- Entry Type -->
          <div class="mb-[15px] sm:mb-0">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Entry Type
            </label>
            <input
              type="text"
              v-model="property.entry_type"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              placeholder="Immediate, 30 days, etc."
            />
          </div>

          <!-- Parking -->
          <div class="mb-[15px] sm:mb-0">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Parking
            </label>
            <input
              type="text"
              v-model="property.parking"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              placeholder="Garage, Street, None, etc."
            />
          </div>

          <!-- Utilities Included -->
          <div class="mb-[15px] sm:mb-0">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Utilities Included
            </label>
            <input
              type="text"
              v-model="property.utilities_included"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              placeholder="Water, Electricity, etc."
            />
          </div>

          <!-- Checkbox Options -->
          <div class="mb-[15px] sm:mb-0">
            <div class="flex items-center mb-2">
              <input 
                type="checkbox" 
                id="elevator" 
                v-model="property.elevator" 
                class="mr-2"
              />
              <label for="elevator" class="text-black dark:text-white">Elevator</label>
            </div>
            <div class="flex items-center mb-2">
              <input 
                type="checkbox" 
                id="furnished" 
                v-model="property.furnished" 
                class="mr-2"
              />
              <label for="furnished" class="text-black dark:text-white">Furnished</label>
            </div>
            <div class="flex items-center">
              <input 
                type="checkbox" 
                id="pets_allowed" 
                v-model="property.pets_allowed" 
                class="mr-2"
              />
              <label for="pets_allowed" class="text-black dark:text-white">Pets Allowed</label>
            </div>
          </div>

          <!-- Assigned To (Agent) -->
          <div class="mb-[15px] sm:mb-0">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Assign To Agent
            </label>
            <select
              v-model="property.assigned_to"
              class="h-[55px] rounded-md border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[13px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500"
            >
              <option value="">Select Agent</option>
              <option v-for="user in users" :key="user.id" :value="user.id">{{ user.display_name }}</option>
            </select>
          </div>

          <!-- Description -->
          <div class="sm:col-span-2 mb-[15px] sm:mb-[20px]">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Description
            </label>
            <textarea
              v-model="property.description"
              class="h-[150px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] py-[10px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              placeholder="Property description"
            ></textarea>
          </div>

          <!-- Features -->
          <div class="col-span-1 sm:col-span-2 mb-[15px] sm:mb-[20px]">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Features
            </label>
            <div class="grid grid-cols-10 sm:grid-cols-12 gap-2 sm:gap-3">
              <div class="col-span-8 sm:col-span-11">
                <input
                  type="text"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] py-[15px] w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  placeholder="Add a feature"
                  v-model="newFeature"
                  @keyup.enter="addFeature"
                  @keydown.enter.prevent
                />
              </div>
              <div class="col-span-2 sm:col-span-1">
                <button 
                  type="button" 
                  class="h-[55px] w-full rounded-md bg-primary-500 text-white flex items-center justify-center hover:bg-primary-400 transition-colors" 
                  @click="addFeature"
                >
                  <i class="material-symbols-outlined">add</i>
                </button>
              </div>
            </div>
            <div v-if="property.features && property.features.length > 0" class="mt-[15px] flex flex-wrap">
              <div v-for="(feature, index) in property.features" :key="index" class="inline-flex items-center mb-[10px] mr-[10px] py-[6px] px-[12px] bg-primary-500 text-white rounded-md">
                <span>{{ feature }}</span>
                <button 
                  type="button" 
                  class="text-white hover:text-gray-200 transition-colors ml-[10px]" 
                  @click="removeFeature(index)"
                >
                  <i class="ri-close-line"></i>
                </button>
              </div>
            </div>
            <div v-else class="text-gray-500 dark:text-gray-400 text-sm mt-[10px]">
              No features added yet. Add some features that make this property stand out.
            </div>
          </div>

          <!-- Neighborhood Info -->
          <div class="col-span-1 sm:col-span-2 mb-[15px] sm:mb-[20px]">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Neighborhood Info
            </label>
            <div class="grid grid-cols-10 sm:grid-cols-12 gap-2 sm:gap-3">
              <div class="col-span-8 sm:col-span-11">
                <input
                  type="text"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] py-[15px] w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  placeholder="Add neighborhood info"
                  v-model="newNeighborhoodInfo"
                  @keyup.enter="addNeighborhoodInfo"
                  @keydown.enter.prevent
                />
              </div>
              <div class="col-span-2 sm:col-span-1">
                <button 
                  type="button" 
                  class="h-[55px] w-full rounded-md bg-primary-500 text-white flex items-center justify-center hover:bg-primary-400 transition-colors" 
                  @click="addNeighborhoodInfo"
                >
                  <i class="material-symbols-outlined">add</i>
                </button>
              </div>
            </div>
            <div v-if="property.neighborhood_info && property.neighborhood_info.length > 0" class="mt-[15px] flex flex-wrap">
              <div v-for="(info, index) in property.neighborhood_info" :key="index" class="inline-flex items-center mb-[10px] mr-[10px] py-[6px] px-[12px] bg-primary-500 text-white rounded-md">
                <span>{{ info }}</span>
                <button 
                  type="button" 
                  class="text-white hover:text-gray-200 transition-colors ml-[10px]" 
                  @click="removeNeighborhoodInfo(index)"
                >
                  <i class="ri-close-line"></i>
                </button>
              </div>
            </div>
            <div v-else class="text-gray-500 dark:text-gray-400 text-sm mt-[10px]">
              No neighborhood information added yet. Add some details about the area.
            </div>
          </div>

          <!-- Recent Renovations -->
          <div class="col-span-1 sm:col-span-2 mb-[15px] sm:mb-[20px]">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Recent Renovations
            </label>
            <div class="grid grid-cols-10 sm:grid-cols-12 gap-2 sm:gap-3">
              <div class="col-span-8 sm:col-span-11">
                <input
                  type="text"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] py-[15px] w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  placeholder="Add renovation detail"
                  v-model="newRenovation"
                  @keyup.enter="addRenovation"
                  @keydown.enter.prevent
                />
              </div>
              <div class="col-span-2 sm:col-span-1">
                <button 
                  type="button" 
                  class="h-[55px] w-full rounded-md bg-primary-500 text-white flex items-center justify-center hover:bg-primary-400 transition-colors" 
                  @click="addRenovation"
                >
                  <i class="material-symbols-outlined">add</i>
                </button>
              </div>
            </div>
            <div v-if="property.recent_renovations && property.recent_renovations.length > 0" class="mt-[15px] flex flex-wrap">
              <div v-for="(renovation, index) in property.recent_renovations" :key="index" class="inline-flex items-center mb-[10px] mr-[10px] py-[6px] px-[12px] bg-primary-500 text-white rounded-md">
                <span>{{ renovation }}</span>
                <button 
                  type="button" 
                  class="text-white hover:text-gray-200 transition-colors ml-[10px]" 
                  @click="removeRenovation(index)"
                >
                  <i class="ri-close-line"></i>
                </button>
              </div>
            </div>
            <div v-else class="text-gray-500 dark:text-gray-400 text-sm mt-[10px]">
              No renovation details added yet. Add some recent upgrades or improvements to the property.
            </div>
          </div>

          <!-- Property Photo Upload -->
          <div class="col-span-1 sm:col-span-2 mb-[15px] sm:mb-[20px]">
            <label class="mb-[10px] text-black dark:text-white font-medium block">
              Add Property Photos
            </label>
            <div id="fileUploader">
              <div
                class="relative flex items-center justify-center overflow-hidden rounded-md py-[60px] sm:py-[88px] px-[15px] sm:px-[20px] border border-gray-200 dark:border-[#172036]"
              >
                <div class="flex items-center justify-center">
                  <div
                    class="w-[35px] h-[35px] border border-gray-100 dark:border-[#15203c] flex items-center justify-center rounded-md text-primary-500 text-lg ltr:mr-[12px] rtl:ml-[12px]"
                  >
                    <i class="ri-upload-2-line"></i>
                  </div>
                  <p class="leading-[1.5]">
                    <strong class="text-black dark:text-white">
                      Click to upload
                    </strong>
                    <br />
                    images for gallery
                  </p>
                </div>
                <input
                  type="file"
                  id="fileInput"
                  multiple
                  @change="handleImageUpload"
                  class="absolute top-0 left-0 right-0 bottom-0 rounded-md z-[1] opacity-0 cursor-pointer"
                  accept="image/*"
                />
              </div>
              
              <!-- Preview of uploaded images with main image selection -->
              <div v-if="uploadedImages.length > 0">
                <div class="mt-4 mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
                  Select a main image for the property:
                </div>
                <div class="flex flex-wrap gap-2 sm:gap-4">
                  <div v-for="(image, index) in uploadedImages" :key="index" class="relative w-full sm:w-auto">
                    <div class="relative group">
                      <img :src="image.preview" class="w-full sm:w-32 h-32 object-cover rounded" />
                      <div class="absolute inset-0 bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center rounded">
                        <button 
                          @click.prevent="removeImage(index)" 
                          class="bg-red-500 text-white w-8 h-8 rounded-full flex items-center justify-center m-1"
                          title="Remove image"
                        >
                          <i class="ri-delete-bin-line"></i>
                        </button>
                        <button 
                          @click.prevent="setMainImage(index)" 
                          class="bg-primary-500 text-white w-8 h-8 rounded-full flex items-center justify-center m-1"
                          title="Set as main image"
                        >
                          <i class="ri-star-line"></i>
                        </button>
                      </div>
                    </div>
                    <div class="mt-1 text-center">
                      <div 
                        class="text-xs px-2 py-1 rounded" 
                        :class="mainImageIndex === index ? 'bg-primary-500 text-white' : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300'"
                      >
                        {{ mainImageIndex === index ? 'Main Image' : 'Gallery Image' }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="mt-[15px] sm:mt-[20px] md:mt-[25px] flex flex-col sm:flex-row">
          <button
            type="button"
            @click="$router.push('/real-estate/property-list')"
            class="font-medium mb-3 sm:mb-0 text-center sm:text-left transition-all rounded-md md:text-md py-[10px] md:py-[12px] px-[20px] md:px-[22px] bg-danger-500 text-white hover:bg-danger-400"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="font-medium text-center sm:text-left transition-all rounded-md md:text-md py-[10px] md:py-[12px] px-[20px] md:px-[22px] bg-primary-500 text-white hover:bg-primary-400 sm:ltr:ml-[15px] sm:rtl:mr-[15px]"
            :disabled="isLoading"
          >
            <span class="inline-block relative ltr:pl-[29px] rtl:pr-[29px]">
              <i
                class="material-symbols-outlined ltr:left-0 rtl:right-0 absolute top-1/2 -translate-y-1/2"
              >
                add
              </i>
              {{ isLoading ? 'Saving...' : 'Create Property' }}
            </span>
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { supabase } from "@/utils/supabase";
import { getUserCurrency } from "@/utils/currency";

interface PropertyData {
  org_id: string | null;
  status: string;
  price: number | null;
  rent_or_sale: string;
  description: string;
  features: string[];
  neighborhood_info: string[];
  country: string;
  city: string;
  address: string;
  recent_renovations: string[];
  availability_date: string | null;
  floor: number | null;
  total_floors: number | null;
  elevator: boolean;
  parking: string;
  furnished: boolean;
  entry_type: string;
  utilities_included: string;
  bedroom: number | null;
  bathroom: number | null;
  size: number | null;
  year_built: number | null;
  property_type: string;
  assigned_to: string | null;
  pets_allowed: boolean;
  main_image_url: string;
  created_by: string | null;
  title: string;
}

interface User {
  id: string;
  display_name: string;
}

export default defineComponent({
  name: "AddProperty",
  setup() {
    const router = useRouter();
    const isLoading = ref(false);
    const error = ref("");
    const users = ref<User[]>([]);
    const uploadedImages = ref<{ file: File; preview: string }[]>([]);
    const mainImageIndex = ref<number | null>(null);
    const newFeature = ref("");
    const newNeighborhoodInfo = ref("");
    const newRenovation = ref("");
    const currencyCode = ref('ILS');

    const property = ref<PropertyData>({
      org_id: null,
      status: "",
      price: null,
      rent_or_sale: "",
      description: "",
      features: [],
      neighborhood_info: [],
      country: "",
      city: "",
      address: "",
      recent_renovations: [],
      availability_date: null,
      floor: null,
      total_floors: null,
      elevator: false,
      parking: "",
      furnished: false,
      entry_type: "",
      utilities_included: "",
      bedroom: null,
      bathroom: null,
      size: null,
      year_built: null,
      property_type: "",
      assigned_to: null,
      pets_allowed: false,
      main_image_url: "",
      created_by: null,
      title: ""
    });

    const getCurrentUser = async () => {
      const { data } = await supabase.auth.getUser();
      if (data?.user) {
        return data.user;
      }
      return null;
    };

    const getOrgId = async () => {
      const user = await getCurrentUser();
      if (!user) return null;

      const { data, error } = await supabase
        .from("user_profiles")
        .select("org_id")
        .eq("user_id", user.id)
        .single();

      if (error) {
        console.error("Error fetching org_id:", error);
        return null;
      }

      return data?.org_id || null;
    };

    const loadUsers = async () => {
      const orgId = await getOrgId();
      if (!orgId) return;

      const { data, error } = await supabase
        .from("user_profiles")
        .select("user_id, display_name")
        .eq("org_id", orgId);

      if (error) {
        console.error("Error loading users:", error);
        return;
      }

      if (data) {
        users.value = (data as any[]).map((user: any) => ({
          id: user.user_id as string,
          display_name: user.display_name as string
        }));
      }
    };

    const handleImageUpload = (event: Event) => {
      const input = event.target as HTMLInputElement;
      if (!input.files) return;

      const files = Array.from(input.files);
      files.forEach(file => {
        const reader = new FileReader();
        reader.onload = (e) => {
          if (e.target?.result) {
            uploadedImages.value.push({
              file,
              preview: e.target.result as string
            });
            
            // Set first uploaded image as main image by default
            if (mainImageIndex.value === null && uploadedImages.value.length === 1) {
              setMainImage(0);
            }
          }
        };
        reader.readAsDataURL(file);
      });
    };

    const removeImage = (index: number) => {
      // If removing the main image, reset main image selection
      if (mainImageIndex.value === index) {
        mainImageIndex.value = null;
        property.value.main_image_url = "";
      } else if (mainImageIndex.value !== null && mainImageIndex.value > index) {
        // Adjust main image index if we're removing an image before it
        mainImageIndex.value--;
      }
      
      uploadedImages.value.splice(index, 1);
    };
    
    const setMainImage = (index: number) => {
      mainImageIndex.value = index;
    };

    const uploadImagesToStorage = async (): Promise<string[]> => {
      if (uploadedImages.value.length === 0) return [];

      const galleryImages: string[] = [];
      const user = await getCurrentUser();
      
      for (const [index, item] of uploadedImages.value.entries()) {
        const file = item.file;
        const filePath = `properties/${user?.id}/${Date.now()}_${file.name}`;
        
        const { data, error } = await supabase.storage
          .from('property')
          .upload(filePath, file);
          
        if (error) {
          console.error('Error uploading image:', error);
          continue;
        }
        
        // Get public URL
        const { data: publicUrlData } = supabase.storage
          .from('property')
          .getPublicUrl(filePath);
          
        const publicUrl = publicUrlData.publicUrl;
        galleryImages.push(publicUrl);
        
        // Set main image URL if this is the selected main image
        if (mainImageIndex.value === index) {
          property.value.main_image_url = publicUrl;
        }
      }
      
      return galleryImages;
    };

    const addFeature = () => {
      if (newFeature.value.trim() !== "") {
        property.value.features.push(newFeature.value);
        newFeature.value = "";
      }
    };

    const removeFeature = (index: number) => {
      property.value.features.splice(index, 1);
    };

    const addNeighborhoodInfo = () => {
      if (newNeighborhoodInfo.value.trim() !== "") {
        property.value.neighborhood_info.push(newNeighborhoodInfo.value);
        newNeighborhoodInfo.value = "";
      }
    };

    const removeNeighborhoodInfo = (index: number) => {
      property.value.neighborhood_info.splice(index, 1);
    };

    const addRenovation = () => {
      if (newRenovation.value.trim() !== "") {
        property.value.recent_renovations.push(newRenovation.value);
        newRenovation.value = "";
      }
    };

    const removeRenovation = (index: number) => {
      property.value.recent_renovations.splice(index, 1);
    };

    const saveProperty = async () => {
      try {
        isLoading.value = true;
        error.value = "";
        
        const user = await getCurrentUser();
        if (!user) {
          error.value = "You must be logged in to create a property";
          return;
        }
        
        const orgId = await getOrgId();
        if (!orgId) {
          error.value = "You must be part of an organization to create a property";
          return;
        }
        
        property.value.org_id = orgId as string;
        property.value.created_by = user.id;
        
        // Upload images to storage and get URLs
        const galleryImages = await uploadImagesToStorage();
        
        // Create the property record without gallery_images
        const { data, error: saveError } = await supabase
          .from('property')
          .insert({
            ...property.value,
            features: property.value.features.join(', '),
            neighborhood_info: property.value.neighborhood_info.join(', '),
            recent_renovations: property.value.recent_renovations.join(', ')
          })
          .select();
          
        if (saveError) {
          error.value = saveError.message;
          console.error("Error saving property:", saveError);
          return;
        }
        
        // Get the newly created property ID
        if (data && data[0] && galleryImages.length > 0) {
          const propertyId = data[0].id;
          
          // Create gallery entries for each image
          const galleryEntries = galleryImages.map(imageUrl => ({
            property_id: propertyId,
            imagelink: imageUrl
          }));
          
          // Insert all gallery entries
          const { error: galleryError } = await supabase
            .from('property_gallery')
            .insert(galleryEntries);
            
          if (galleryError) {
            console.error("Error saving gallery images:", galleryError);
            // Continue with redirect even if gallery save fails
          }
        }
        
        // Redirect to property list on success
        router.push('/real-estate/property-list');
      } catch (err) {
        console.error("Error:", err);
        error.value = err instanceof Error ? err.message : "An unknown error occurred";
      } finally {
        isLoading.value = false;
      }
    };

    // קבלת המטבע של הארגון
    const getCurrency = async () => {
      try {
        currencyCode.value = await getUserCurrency();
      } catch (error) {
        console.error('Error fetching currency:', error);
      }
    };

    onMounted(async () => {
      await getCurrency();
      await loadUsers();
    });

    return {
      property,
      users,
      isLoading,
      error,
      uploadedImages,
      mainImageIndex,
      newFeature,
      newNeighborhoodInfo,
      newRenovation,
      handleImageUpload,
      removeImage,
      setMainImage,
      addFeature,
      removeFeature,
      addNeighborhoodInfo,
      removeNeighborhoodInfo,
      addRenovation,
      removeRenovation,
      saveProperty
    };
  }
});
</script>
